<div *ngIf="connection && connection.id">
  <div id="connection-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="connection.name">{{connection.name}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Weight:</span>
      <span class="map-summary-item-value" [title]="connection.weight">{{connection.weight}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Operative state:</span>
      <span class="map-summary-item-value" [title]="connection.operState">{{connection.operState}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Quality:</span>
      <span class="map-summary-item-value" [title]="connection.result">{{connection.result}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Transport Type:</span>
      <span class="map-summary-item-value" [title]="connection.transportType">{{connection.transportType}}</span>
    </div>

    <br/>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Node-1:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].srcNodeName">{{connection.connections[0].srcNodeName}}</span>
    </div>


    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Operative State:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].operState">{{connection.connections[0].operState}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Routing I/F:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].srcRoutingInterfaceName">{{connection.connections[0].srcRoutingInterfaceName}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">IPGroup Name:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].name">{{connection.connections[0].name}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Quality:</span>
      <span class="map-summary-item-value" [title]="connection.connections[0].result">{{connection.connections[0].result}}</span>
    </div>

    <br/>

    <div *ngIf="connection.type !== 'NODE_TO_THIRD_PARTY'">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Node-2:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].srcNodeName">{{connection.connections[1].srcNodeName}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Operative State:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].operState">{{connection.connections[1].operState}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Routing I/F:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].srcRoutingInterfaceName">{{connection.connections[1].srcRoutingInterfaceName}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">IPGroup Name:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].name">{{connection.connections[1].name}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Quality:</span>
        <span class="map-summary-item-value" [title]="connection.connections[1].result">{{connection.connections[1].result}}</span>
      </div>
    </div>
  </div>
</div>
